import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  TEST_SCORES_LIST_START: "TEST_SCORES_LIST_START",
  TEST_SCORES_SAVE_LIST_START: "TEST_SCORES_SAVE_LIST_START",
  TEST_SCORES_LIST_SUCCESS: "TEST_SCORES_LIST_SUCCESS",
  TEST_SCORES_LIST_FAILED: "TEST_SCORES_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const testScoreListStart = (data) => ({
  type: actionType.TEST_SCORES_LIST_START,
  payload: data,
});
export const testScoreSaveListStart = (data) => ({
  type: actionType.TEST_SCORES_SAVE_LIST_START,
  payload: data,
});

export const testScoreListSuccess = (data) => ({
  type: actionType.TEST_SCORES_LIST_SUCCESS,
  payload: data,
});

export const testScoreListFailed = (data) => ({
  type: actionType.TEST_SCORES_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function testScoreListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.TEST_SCORES_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.TEST_SCORES_SAVE_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.TEST_SCORES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.TEST_SCORES_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* testScoreListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(testScoreListSuccess(response.data.data.allTestscores.Testscores ));
    } else {
      messagePopup("", "Test And Score List failed", "error");
      yield put(testScoreListSuccess(" Test And Score List failed"));
    }
  } catch (error) {
    messagePopup("", "Test And Score List failed", "error");
    yield put(testScoreListSuccess("Test And Score List failed"));
  }
}

export function* testScoreSaveListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(testScoreListSuccess({ testscroreData: response.data.data.saveTestscore }));
    } else {
      messagePopup("", "Test And Score List failed", "error");
      yield put(testScoreListSuccess(" Test And Score List failed"));
    }
  } catch (error) {
    messagePopup("", "Test And Score List failed", "error");
    yield put(testScoreListSuccess("Test And Score List failed"));
  }
}


export function* watchtestScoreListSaga() {
  yield takeEvery(actionType.TEST_SCORES_LIST_START, testScoreListSaga);
  yield takeEvery(actionType.TEST_SCORES_SAVE_LIST_START, testScoreSaveListSaga);
}
